// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/contratti-insegna?insegnaClienteId=N',
    requestBody: null,
    response: '[{"id":3,"anno":2026,"descrizione":"Accordo quadro 2026","riepilogoAI":"...","allegati":[{"id":7}],"updatedAt":"2026-03-02T10:00:00.000Z"}]'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
